app.BadgeList = app.AbstractCollection.extend({
  model: app.Badge,

  url() {
    return '/api/v2/badges';
  },
});
